import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  InputBase,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    position: "absolute",
    top: 70,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1000,
    width: "80%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  searchBox: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    borderRadius: 25,
    // height:47,
    backgroundColor: "#FFFFFF",
    // backgroundColor: '#F6F6F6',
    //boxShadow: '0 0 0 rgba(0,0,0,0.1)',
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
    color: "#666",
  },
  locationIcon: {
    color: "#1075c2",
    cursor: "pointer",
  },
  actionIcons: {
    display: "flex",
    alignItems: "center",
  },
}));

const LocationSearchInput = ({ onSearch, onReset, hasSearched }) => {
  const classes = useStyles();
  const [zipCode, setZipCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    if (zipCode) {
      setIsLoading(true);
      try {
        await onSearch(zipCode);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleReset = () => {
    setZipCode("");
    onReset();
  };

  return (
    <div className={classes.searchContainer}>
      <Paper className={classes.searchBox}>
        <IconButton
          className={classes.iconButton}
          aria-label="location"
          onClick={() => {
            handleReset();
          }}
        >
          <LocationOnIcon className={classes.locationIcon} />
        </IconButton>
        <InputBase
          className={classes.input}
          //placeholder="Search plumbers by zip code"
          placeholder="zipcode"
          value={zipCode}
          onChange={(e) => setZipCode(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
        />
        {isLoading ? (
          <CircularProgress size={24} style={{ margin: "0 12px" }} />
        ) : (
          <div className={classes.actionIcons}>
            {hasSearched && (
              <IconButton
                className={classes.iconButton}
                aria-label="reset"
                onClick={handleReset}
              >
                <CloseIcon />
              </IconButton>
            )}
            <IconButton
              className={classes.iconButton}
              aria-label="search"
              onClick={handleSearch}
            >
              <SearchIcon />
            </IconButton>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default LocationSearchInput;
